import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useAccountBase } from '../../account/AccountContext';
import { CallDetail } from '../../components/CallDetail';

/** Full-page call detail (mobile). Back button up top returns to the calls list. */
export default function CustomerCallDetailPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const base = useAccountBase();
  const { callId = '' } = useParams();
  return (
    <div className="flex h-full flex-col">
      {/* Sticky top bar — stays put while the detail scrolls under it. */}
      <div className="shrink-0 border-b border-border bg-background px-4 py-3">
        <button
          type="button"
          onClick={() => navigate(base)}
          className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden /> {t('action.back')}
        </button>
      </div>
      <div className="flex-1 overflow-y-auto px-4 pt-6 pb-24">
        <div className="mx-auto max-w-md">
          <CallDetail callId={callId} />
        </div>
      </div>
    </div>
  );
}
